import React, { Component, Fragment } from 'react';
import {getInstaFoto} from "../../utility/serverUtility";
import {isSuccess} from "../../utility/utility";
import Feed from "./Feed";
import SingleFeed from "./SingleFeed";

import social2 from '../../configs/social2.json';

class Canvas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            size: 9,
            instaFoto:[{
                id:"0000",
                media_type:"IMAGE",
                media_url:"assets/img/banner/EmptyIMGInsta.jpg",
                search:false,
                keyword:null,
            }]
        }


    }
    async componentDidMount() {
        //console.log("CALL ALL ROOM")
        this.fetchInstagramPost();
    }

    async fetchInstagramPost () {
        const response = await getInstaFoto(this.state.size)
        if (isSuccess(response)) {
            let images  = response.data.risultato.InstaPhoto.filter(function(element) {
                return element.media_type!="VIDEO";
            });
            this.setState({instaFoto:images})
        }
    }
    changeKeyWord(e){

        let value=e.target.value
        //console.log(value)
        if(e.target.value==""){
            this.setState({search:false,keyword:null})
        }
        else{
            this.setState({search:true,keyword:value})

        }
    }
    render() {
        return (
            <Fragment>
                {/* Search Widget */}
                <div className="widget search-widget">
                    <h5 className="widget-title">Cerca la tua casa vacanza</h5>
                    <form>
                        <input onChange={e=>this.changeKeyWord(e)} type="text" placeholder="Cerca..." />
                        {/*<button type="submit"><i className="far fa-search" /></button>*/}
                    </form>
                    {this.state.search && <SingleFeed keyword={this.state.keyword}/>}
                </div>
                {/* Instagram Feeds Widget */}
                <div className="sidebar-insta" style={{padding: "0px"}}>
                <div className="widget instagram-feed-widget mb-40">
                    <h5 className="widget-title">Instagram Feeds</h5>
                    <ul>
                        {this.state.instaFoto.map((item, i) => (
                            <li key={i}><Feed key={item.id} feed={item} /></li>
                        ))}

                    </ul>
                </div>
                </div>
                {/* Social Link */}
                <div className="widget social-link">
                    <h5 className="widget-title">Seguici</h5>
                    <ul>
                        {social2.map((social,index)=>
                            <li> <a href={social.link} target="_blank" ><i className={social.icon} /> </a>
                            </li>
                        )}

                    </ul>
                </div>
            </Fragment>
        );
    }
}

export default Canvas;